// extracted by mini-css-extract-plugin
export var externalLink = "_78-0";
export var internalLinkLabel = "_78-1";